export const RISK_TYPE_REPORT = 'risk';
export const MARKET_TYPE_REPORT = 'market';
export const GROUP_BY_DESC_SORTING = 'groupByDesc';
export const DISPLAY_BY_DESC_SORTING = 'displayByDesc';
export const ROLL_BY_DESC_SORTING = 'rollByDesc';
export const VANTAGE_V3_NAME = 'VantageScore 3.0®';

export const DISTRIBUTION_VALUE_TEXT_KEY = 'valueText';